import { logger } from "@moodys/mdc-frontend.services.logger";

import {
  InitLiveChatArgs,
  isLiveagentInWindow,
} from "components/LiveChat/liveChat.types";
import { config } from "config";

export const LIVE_CHAT_ONLINE_ELEMENT_ID = `liveagent_button_online_${config.LIVE_CHAT.BUTTON_ID}`;

export const initLiveChat = async ({
  insiteId,
  handleChatAvailabilityState,
}: InitLiveChatArgs) => {
  if (!isLiveagentInWindow(window)) {
    return;
  }

  if (!window._laq) {
    window._laq = [];
  }

  window._laq.push(() => {
    if (isLiveagentInWindow(window)) {
      // Shows element with specified id when chat is available, otherwise hides it
      window.liveagent.showWhenOnline(
        config.LIVE_CHAT.BUTTON_ID,
        document.getElementById(LIVE_CHAT_ONLINE_ELEMENT_ID)
      );
    } else {
      logger.debug({ message: "window.liveagent is undefined" });
    }
  });

  window.liveagent.addButtonEventHandler(
    config.LIVE_CHAT.BUTTON_ID,
    (event: unknown) => {
      if (isLiveagentInWindow(window)) {
        if (event === window.liveagent.BUTTON_EVENT.BUTTON_AVAILABLE) {
          handleChatAvailabilityState({ isEnabled: true, isAvailable: true });
        } else if (event === window.liveagent.BUTTON_EVENT.BUTTON_UNAVAILABLE) {
          handleChatAvailabilityState({ isEnabled: true, isAvailable: false });
        }
      }
    }
  );

  // Creates a custom detail called InsiteId and sets the value to insiteId
  window.liveagent.addCustomDetail("InsiteId", insiteId);

  // An auto-query that searches Contacts whose Insite_Person_Id__c field exactly matches the insiteId value.
  // If no result is found, it will NOT create a Contact record with the Insite_Person_Id__c field.
  window.liveagent
    .findOrCreate("Contact")
    .map("Insite_Person_Id__c", "InsiteId", true, true, false);

  await window.liveagent.init(
    config.LIVE_CHAT.URL,
    config.LIVE_CHAT.DEPLOYMENT_ID,
    config.LIVE_CHAT.ORG_ID
  );
};

export const startLiveChat = () => {
  if (isLiveagentInWindow(window)) {
    window.liveagent.startChat(config.LIVE_CHAT.BUTTON_ID);
  }
};
